export default "__VITE_ASSET__CAsmIM6T__"